import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to hold sorting direction
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from summColumn filter
        );

        // Custom data filter for summing column
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    var size = $$('datatable4').getPager().config.size; // Getting page size
                    var page = $$('datatable4').getPage(); // Getting current page
                    var first = size * page; // Calculating first index of current page
                    var last = first + size - 1; // Calculating last index of current page
                    var count = 0; // Counter for iteration
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Summing values within current page
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Formatting result
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from summColumn filter
        );

        // Returning the main configuration object for the view
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table view
                            id: 'datatable4', // Unique ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 90, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (obj.State === 'A') {
                                            if (devConfig.getPermAction('depositRequestsShopDecline', 'Pay')) {
                                                if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                                    return (
                                                        "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>" +
                                                        "<span placeholder='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsShopPrinter'></span>"
                                                    );
                                                } else {
                                                    return (
                                                        "<span class='webix_icon wxi-close details prm-depositRequestsShopDecline'></span>" +
                                                        "<span placeholder='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsShopDecline'></span>"
                                                    );
                                                }
                                            } else {
                                                if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                                    return "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>";
                                                } else {
                                                    return "<span class='webix_icon wxi-close details'></span>";
                                                }
                                            }
                                        }
                                        if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                            return "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>";
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>";
                                        }
                                    },
                                    footer: 'Total:', // Footer text for the column
                                },
                                { id: 'Id', header: 'ID', width: 100 }, // Column for ID
                                {
                                    id: 'ClientId',
                                    header: _('ID Usuario'), // Column for User ID
                                    width: 100,
                                },
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Column for Creation Date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Provider',
                                    header: _('Proveedor'), // Column for Provider
                                    width: 150,
                                },
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombre Sistema Pasarela Pago'), // Column for Payment System Name
                                    width: 250,
                                },
                                {
                                    id: 'TypeName',
                                    header: _('Tipo'), // Column for Type
                                    width: 100,
                                },
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'), // Column for Currency
                                    width: 100,
                                },
                                {
                                    id: 'Tax',
                                    header: _('Impuesto Deposito'), // Column for Deposit Tax
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Column for Value
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'ModifiedLocal',
                                    header: _('Modificado'), // Column for Modified Date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // Column for State
                                    options: [
                                        { id: '', value: _('None') }, // Option for None
                                        { id: 'A', value: _('Pagada') }, // Option for Paid
                                        { id: 'C', value: _('Cancelado') }, // Option for Canceled
                                        { id: 'I', value: _('Inactivo') }, // Option for Inactive
                                        { id: 'R', value: _('Rechazada') }, // Option for Rejected
                                    ],
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('External ID'), // Column for External ID
                                    width: 150,
                                },
                                { id: 'Ip', header: 'IP', width: 150 }, // Column for IP
                                {
                                    id: 'CashDeskId',
                                    header: _('Recepcion de Efectivo'), // Column for Cash Reception
                                    width: 150,
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Getting the clicked item
                                    this.$scope.app.callEvent('deposit:id', [
                                        item.Id, // Triggering event with item ID
                                    ]);
                                    // Conditional display based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                                printer: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea imprimir recibo?'), // Confirmation message
                                        ok: _('Imprimir'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Getting the clicked item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/ReprintDeposit', // API endpoint for reprinting deposit
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var dat = JSON.parse(
                                                                    text, // Parsing response
                                                                );
                                                                if (dat.HasError) {
                                                                    webix.message({
                                                                        title: '¡Error!', // Error title
                                                                        type: 'alert-error', // Error type
                                                                        text: _(
                                                                            dat.AlertMessage, // Error message
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Creating a window for invoice selection
                                                                            width: 450,
                                                                            height: 450,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Seleccione tipo de factura', // Label for invoice type selection
                                                                                        ),
                                                                                        align: 'center',
                                                                                    },
                                                                                    {
                                                                                        view: 'icon',
                                                                                        icon: 'wxi-close', // Close icon
                                                                                        click: function () {
                                                                                            this.getTopParentView().hide(); // Close the window
                                                                                        },
                                                                                    },
                                                                                ],
                                                                            },
                                                                            position: 'center', // Center position
                                                                            modal: true, // Modal window
                                                                            body: {
                                                                                view: 'form',
                                                                                elements: [
                                                                                    {
                                                                                        cols: [
                                                                                            {
                                                                                                view: 'button',
                                                                                                value: _(
                                                                                                    'POS', // Button for POS invoice
                                                                                                ),
                                                                                                click: function () {
                                                                                                    webix
                                                                                                        .ui({
                                                                                                            view: 'window', // Creating a window for PDF display
                                                                                                            width: 500,
                                                                                                            height: 700,
                                                                                                            head: {
                                                                                                                view: 'toolbar',
                                                                                                                cols: [
                                                                                                                    {
                                                                                                                        view: 'label',
                                                                                                                        label: _(
                                                                                                                            'Factura', // Label for invoice
                                                                                                                        ),
                                                                                                                    },
                                                                                                                    {
                                                                                                                        view: 'button',
                                                                                                                        label: 'X', // Close button
                                                                                                                        width: 100,
                                                                                                                        align: 'right',
                                                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                            id: 'windowfact2', // Window ID
                                                                                                            modal: true, // Modal window
                                                                                                            position:
                                                                                                                'center', // Center position
                                                                                                            body: {
                                                                                                                rows: [
                                                                                                                    {
                                                                                                                        template:
                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                        })
                                                                                                        .show(); // Show the window
                                                                                                    var reader =
                                                                                                        new FileReader(); // File reader for PDF
                                                                                                    reader.onload =
                                                                                                        function (
                                                                                                            event,
                                                                                                        ) {
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).clear(); // Clear previous PDF
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).parse({
                                                                                                                data: event
                                                                                                                    .target
                                                                                                                    .result, // Parsing PDF data
                                                                                                            });
                                                                                                        };
                                                                                                    function b64toBlob(
                                                                                                        b64Data,
                                                                                                        contentType,
                                                                                                        sliceSize,
                                                                                                    ) {
                                                                                                        contentType =
                                                                                                            contentType ||
                                                                                                            '';
                                                                                                        sliceSize =
                                                                                                            sliceSize ||
                                                                                                            512; // Default slice size
                                                                                                        var byteCharacters =
                                                                                                            atob(
                                                                                                                b64Data, // Decoding base64 data
                                                                                                            );
                                                                                                        var byteArrays =
                                                                                                            [];
                                                                                                        for (
                                                                                                            var offset = 0;
                                                                                                            offset <
                                                                                                            byteCharacters.length;
                                                                                                            offset +=
                                                                                                                sliceSize
                                                                                                        ) {
                                                                                                            var slice =
                                                                                                                byteCharacters.slice(
                                                                                                                    offset,
                                                                                                                    offset +
                                                                                                                        sliceSize,
                                                                                                                );
                                                                                                            var byteNumbers =
                                                                                                                new Array(
                                                                                                                    slice.length,
                                                                                                                );
                                                                                                            for (
                                                                                                                var i = 0;
                                                                                                                i <
                                                                                                                slice.length;
                                                                                                                i++
                                                                                                            ) {
                                                                                                                byteNumbers[
                                                                                                                    i
                                                                                                                ] =
                                                                                                                    slice.charCodeAt(
                                                                                                                        i,
                                                                                                                    ); // Converting characters to byte numbers
                                                                                                            }
                                                                                                            var byteArray =
                                                                                                                new Uint8Array(
                                                                                                                    byteNumbers,
                                                                                                                );
                                                                                                            byteArrays.push(
                                                                                                                byteArray, // Pushing byte array to the array
                                                                                                            );
                                                                                                        }
                                                                                                        var blob =
                                                                                                            new Blob(
                                                                                                                byteArrays,
                                                                                                                {
                                                                                                                    type: contentType, // Creating a blob with the byte arrays
                                                                                                                },
                                                                                                            );
                                                                                                        return blob; // Returning the blob
                                                                                                    }
                                                                                                    var contentType =
                                                                                                        'application/pdf'; // Content type for PDF
                                                                                                    var b64Data =
                                                                                                        dat.PdfPOS; // Base64 data for PDF
                                                                                                    var blob =
                                                                                                        b64toBlob(
                                                                                                            b64Data,
                                                                                                            contentType,
                                                                                                        ); // Converting base64 to blob
                                                                                                    var file =
                                                                                                        window.URL.createObjectURL(
                                                                                                            blob, // Creating object URL for the blob
                                                                                                        );
                                                                                                    document.querySelector(
                                                                                                        'iframe',
                                                                                                    ).src = file; // Setting iframe source to the blob URL
                                                                                                    var printWindow =
                                                                                                        window.open(
                                                                                                            file,
                                                                                                            '',
                                                                                                            'width=800,height=500', // Opening print window
                                                                                                        );
                                                                                                    printWindow.print(); // Triggering print
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                                view: 'button',
                                                                                                value: _(
                                                                                                    'CARTA', // Button for CARTA invoice
                                                                                                ),
                                                                                                click: function () {
                                                                                                    webix
                                                                                                        .ui({
                                                                                                            view: 'window', // Creating a window for PDF display
                                                                                                            width: 500,
                                                                                                            height: 700,
                                                                                                            head: {
                                                                                                                view: 'toolbar',
                                                                                                                cols: [
                                                                                                                    {
                                                                                                                        view: 'label',
                                                                                                                        label: _(
                                                                                                                            'Factura', // Label for invoice
                                                                                                                        ),
                                                                                                                    },
                                                                                                                    {
                                                                                                                        view: 'button',
                                                                                                                        label: 'X', // Close button
                                                                                                                        width: 100,
                                                                                                                        align: 'right',
                                                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                            id: 'windowfact2', // Window ID
                                                                                                            modal: true, // Modal window
                                                                                                            position:
                                                                                                                'center', // Center position
                                                                                                            body: {
                                                                                                                rows: [
                                                                                                                    {
                                                                                                                        template:
                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                        })
                                                                                                        .show(); // Show the window
                                                                                                    var reader =
                                                                                                        new FileReader(); // File reader for PDF
                                                                                                    reader.onload =
                                                                                                        function (
                                                                                                            event,
                                                                                                        ) {
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).clear(); // Clear previous PDF
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).parse({
                                                                                                                data: event
                                                                                                                    .target
                                                                                                                    .result, // Parsing PDF data
                                                                                                            });
                                                                                                        };
                                                                                                    function b64toBlob(
                                                                                                        b64Data,
                                                                                                        contentType,
                                                                                                        sliceSize,
                                                                                                    ) {
                                                                                                        contentType =
                                                                                                            contentType ||
                                                                                                            '';
                                                                                                        sliceSize =
                                                                                                            sliceSize ||
                                                                                                            512; // Default slice size
                                                                                                        var byteCharacters =
                                                                                                            atob(
                                                                                                                b64Data, // Decoding base64 data
                                                                                                            );
                                                                                                        var byteArrays =
                                                                                                            [];
                                                                                                        for (
                                                                                                            var offset = 0;
                                                                                                            offset <
                                                                                                            byteCharacters.length;
                                                                                                            offset +=
                                                                                                                sliceSize
                                                                                                        ) {
                                                                                                            var slice =
                                                                                                                byteCharacters.slice(
                                                                                                                    offset,
                                                                                                                    offset +
                                                                                                                        sliceSize,
                                                                                                                );
                                                                                                            var byteNumbers =
                                                                                                                new Array(
                                                                                                                    slice.length,
                                                                                                                );
                                                                                                            for (
                                                                                                                var i = 0;
                                                                                                                i <
                                                                                                                slice.length;
                                                                                                                i++
                                                                                                            ) {
                                                                                                                byteNumbers[
                                                                                                                    i
                                                                                                                ] =
                                                                                                                    slice.charCodeAt(
                                                                                                                        i,
                                                                                                                    ); // Converting characters to byte numbers
                                                                                                            }
                                                                                                            var byteArray =
                                                                                                                new Uint8Array(
                                                                                                                    byteNumbers,
                                                                                                                );
                                                                                                            byteArrays.push(
                                                                                                                byteArray, // Pushing byte array to the array
                                                                                                            );
                                                                                                        }
                                                                                                        var blob =
                                                                                                            new Blob(
                                                                                                                byteArrays,
                                                                                                                {
                                                                                                                    type: contentType, // Creating a blob with the byte arrays
                                                                                                                },
                                                                                                            );
                                                                                                        return blob; // Returning the blob
                                                                                                    }
                                                                                                    var contentType =
                                                                                                        'application/pdf'; // Content type for PDF
                                                                                                    var b64Data =
                                                                                                        dat.Pdf; // Base64 data for PDF
                                                                                                    var blob =
                                                                                                        b64toBlob(
                                                                                                            b64Data,
                                                                                                            contentType,
                                                                                                        ); // Converting base64 to blob
                                                                                                    var file =
                                                                                                        window.URL.createObjectURL(
                                                                                                            blob, // Creating object URL for the blob
                                                                                                        );
                                                                                                    document.querySelector(
                                                                                                        'iframe',
                                                                                                    ).src = file; // Setting iframe source to the blob URL
                                                                                                    var printWindow =
                                                                                                        window.open(
                                                                                                            file,
                                                                                                            '',
                                                                                                            'width=800,height=500', // Opening print window
                                                                                                        );
                                                                                                    printWindow.print(); // Triggering print
                                                                                                },
                                                                                            },
                                                                                        ],
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                'icon-tranfer': function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    var item = vvthis.getItem(id); // Getting the clicked item
                                    webix
                                        .modalbox({
                                            id: 'modalAgent', // Modal box ID
                                            title: _('¿ Qué desea realizar ?'), // Modal title
                                            buttons: [
                                                'Rechazar Depósito', // Button for rejecting deposit
                                                'Cancelar', // Cancel button
                                            ],
                                            text: '',
                                            width: 200,
                                        })
                                        .then(function (result) {
                                            var state; // Variable to hold state
                                            switch (result) {
                                                case '0':
                                                    state = '1'; // Setting state for rejection
                                                    break;
                                            }
                                            console.log(result); // Logging result
                                            if (result === '0') {
                                                var tthis = this;
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Financial/ActionDepositUser', // API endpoint for deposit action
                                                        '{ "Id":' + item.Id + ', "State":"' + state + '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parsing response
                                                                );
                                                                if (data.HasError) {
                                                                    webix.message(
                                                                        'No se proceso la solicitud. Comunicarse con soporte. ', // Error message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Hiding the modal
                                                                } else {
                                                                    item.State = 'I'; // Updating item state
                                                                    webix.message(
                                                                        'Se ha se procesado la solicitud satisfactoriamente. ', // Success message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Hiding the modal
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        });
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>", // Overlay for loading
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hiding overlay after load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extending with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // No data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enabling tooltips
                            footer: true, // Enabling footer
                            math: true, // Enabling math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerAA', // Pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            view: 'treetable', // Tree table view
                            id: 'datatable2', // Unique ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Column for Creation Date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 220,
                                    format: dateFormat, // Date formatting
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Grouping template
                                            );
                                        return obj.CreatedLocal; // Returning creation date
                                    },
                                },
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombre Sistema Pasarela Pago'), // Column for Payment System Name
                                    width: 250,
                                },
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'), // Column for Currency
                                    width: 100,
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Column for Value
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>", // Overlay for loading
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hiding overlay after load
                                },
                            },
                            ready: function () {
                                console.log('count ' + this.count()); // Logging count
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extending with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // No data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enabling tooltips
                            footer: true, // Enabling footer
                            math: true, // Enabling math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: {
                                size: 10000, // Pager size
                                id: 'pagerr', // Pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        var gridppal = $$('datatable4'); // Main data table
        var grid2 = $$('datatable2'); // Secondary data table
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2BetShop'; // API endpoint for deposits
        var url2 = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2BetShop'; // API endpoint for withdrawals
        grid2.hide(); // Hiding secondary grid initially
        var flag = false; // Flag for export operation
        $$('toolbar2').hide(); // Hiding secondary toolbar

        // Event handler for after loading data in the secondary grid
        grid2.attachEvent('onAfterLoad', function () {
            $$('datatable2').data.group({
                by: 'Provider', // Grouping by Provider
                map: {
                    Partner: ['Partner'],
                    Provider: ['Provider'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    CurrencyId: ['CurrencyId'],
                    Amount: ['Amount', 'sum'], // Summing Amount
                },
            });
            $$('datatable2').data.group({
                by: 'CurrencyId', // Grouping by Currency
                map: {
                    Partner: ['Partner'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    CurrencyId: ['CurrencyId'],
                    Amount: ['Amount', 'sum'], // Summing Amount
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return (
                        "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country // Grouping by Country with icon
                    );
                },
                map: {
                    Partner: ['Partner'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    Amount: ['Amount', 'sum'], // Summing Amount
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return "<i class='partner " + obj.Partner + "'></i>"; // Grouping by Partner with icon
                },
                map: {
                    Partner: ['Partner'],
                    Amount: ['Amount', 'sum'], // Summing Amount
                },
            });
        });

        var filter = ''; // Variable to hold filter string
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Converting filter data to entries
            var string1 = ''; // String for date filters
            var string2 = ''; // String for sorting filters
            var providergroup = 0; // Variable to check if provider group is applied
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Setting provider group flag
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[ClientId]='; // Sorting by ClientId
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[CreatedLocal]='; // Sorting by CreatedLocal
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sorting by Amount
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Splitting date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Adding dateTo to filter
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Formatting date
                                string1 = string1 + '&dateFrom=' + date; // Adding dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Adding dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Converting nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Creating date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adding dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Creating date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adding dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                gridppal.show(); // Showing main grid
                grid2.hide(); // Hiding secondary grid
                gridppal.clearAll(); // Clearing main grid data
                gridppal.load(
                    url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2, // Loading data with filters
                );
                $$('toolbar').show(); // Showing main toolbar
                $$('toolbar2').hide(); // Hiding secondary toolbar
            } else {
                if (screen.width > 500 || screen.height > 500) {
                    $$('dColl').collapse(); // Collapsing details if screen size is sufficient
                }
                grid2.show(); // Showing secondary grid
                gridppal.hide(); // Hiding main grid
                grid2.clearAll(); // Clearing secondary grid data
                grid2.load(
                    url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2, // Loading data with filters
                );
                grid2.adjust(); // Adjusting secondary grid
                $$('toolbar2').show(); // Showing secondary toolbar
                $$('toolbar').hide(); // Hiding main toolbar
            }
            $$('filterPopup').hide(); // Hiding filter popup
            filter = string1 + string2; // Storing filter string
        });

        // Event handler for exporting data
        this.on(this.app, 'export:filter', (filterData) => {
            console.log(filterData); // Logging filter data
            flag = true; // Setting export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjusting first index for export
            } else {
                firstfirst = filterData.first;
            }
            gridppal.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Loading data for export
            );
            $$('datatable4').attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = $$('datatable4').getPager().config.size; // Getting pager size
                        var page = $$('datatable4').getPage(); // Getting current page
                        var first = size * page; // Calculating first index of current page
                        var last = first + size - 1; // Calculating last index of current page
                        if ($$('Export').getValue() == '1') {
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Deleting format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        'Depósitos' +
                                        ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        $$('datatable4').getIndexById(obj.id) >= first &&
                                        $$('datatable4').getIndexById(obj.id) <= last // Filtering data for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                    'Depósitos', // Filename for export
                                ignore: { detailTittle: true }, // Ignoring specific columns
                                footer: false, // Not including footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            'Depósitos' +
                                            ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF($$('datatable4'), {
                                    filter: function (obj) {
                                        return (
                                            $$('datatable4').getIndexById(obj.id) >= first &&
                                            $$('datatable4').getIndexById(obj.id) <= last // Filtering data for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Depósitos', // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignoring specific columns
                                    footer: false, // Not including footer in export
                                });
                            }
                        }
                        flag = false; // Resetting export flag
                        $$('Export').setValue(''); // Resetting export selection
                    }
                }.bind(this),
            );
        });

        // Event handler for sorting in the main grid
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            console.log('as: ' + as); // Logging sort direction
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Loading data with sorting
            );
        });

        // Event handler for sorting in the secondary grid
        grid2.attachEvent('onAfterSort', function (by, dir, as) {
            grid2.load(
                url + '?start=0&count=' + grid2.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Loading data with sorting
            );
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            gridppal.load(
                gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + Id, // Loading data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
